import { useState } from "react";
import { format as dateFnsFormat } from "date-fns";
import { useAPISaveAttendance } from "./api-save-attendance";

export const useAttendanceSaveHandlers = ({ selectedDate, fetchListData, getSelectedData }) => {
  const { loading: savingLoading, handleSaveAttendance, handleSaveManyAttendance } = useAPISaveAttendance();
  const [savingIds, setSavingIds] = useState([]);

  const handleSaveSelected = async () => {
    const selectedData = getSelectedData();
    if (selectedData.length === 0) {
      return;
    }

    // Validate that all items have required fields
    const invalidItems = selectedData.filter(
      (item) => !item.employee_id || !item.date
    );
    if (invalidItems.length > 0) {
      console.error("Invalid items:", invalidItems);
      return;
    }

    // Mark all selected items as present (attend: 1)
    const dataToSave = selectedData.map((item) => ({
      ...item,
      attend: 1,
    }));

    await handleSaveManyAttendance(dataToSave, () => {
      // Refresh the list after saving
      fetchListData(selectedDate);
    });
  };

  const handleSaveIndividual = async (item) => {
    if (!item.employee_id) {
      console.error("Missing employee_id:", item);
      return;
    }

    const dateString = dateFnsFormat(selectedDate, "yyyy-MM-dd");
    const saveData = {
      id: item.id,
      employee_id: item.employee_id,
      date: item.date || dateString,
      attend: 1,
      keterangan: item.keterangan || null,
    };

    setSavingIds((prev) => [...prev, item.id]);
    await handleSaveAttendance(saveData, () => {
      setSavingIds((prev) => prev.filter((id) => id !== item.id));
      fetchListData(selectedDate);
    });
  };

  const handleToggleAttend = async (item) => {
    if (!item.employee_id) {
      console.error("Missing employee_id:", item);
      return;
    }

    const newAttendValue = item.attend === 1 ? 0 : 1;
    const dateString = dateFnsFormat(selectedDate, "yyyy-MM-dd");
    const saveData = {
      id: item.id,
      employee_id: item.employee_id,
      date: item.date || dateString,
      attend: newAttendValue,
      keterangan: item.keterangan || null,
    };

    setSavingIds((prev) => [...prev, item.id]);
    await handleSaveAttendance(saveData, () => {
      setSavingIds((prev) => prev.filter((id) => id !== item.id));
      fetchListData(selectedDate);
    });
  };

  return {
    savingLoading,
    savingIds,
    handleSaveSelected,
    handleSaveIndividual,
    handleToggleAttend,
  };
};
